import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import useManagementDashboard from './useManagementDashboard';
import * as XLSX from 'xlsx';
import { axiosClient } from '../../../../library/Service/axiosClient';
import moment from 'moment';
import { set } from 'date-fns';
import { getFlexColDomainValueForCode } from '../../../../library/Core/SmartFunctions';
import SessionContext from '../../../../library/Core/SessionContext';

const ReportLayoutComponent = (prop: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState, sessionDispatch } = useContext(SessionContext);
    const { setStateValue } = useManagementDashboard();
    
    const instituteId = sessionState?.primaryInstitute || '10000005493'; // Default to a known institute ID if not set
    const instituteDetails = JSON.parse(getFlexColDomainValueForCode(instituteId,'INSTITUTE_DOMAIN',state));
    const instituteType = instituteDetails?.institute_type
    const isk12 = ['SCHOOL','K12_SCHOOL','PRE_SCHOOL'].includes(instituteType);

    const toggleAccordionState = () => {
        const newState = state.data.accordionState === 'EXPANDED' ? 'COLLAPSED' : 'EXPANDED';
        const newValue = state.data.accordionState === 'EXPANDED' ? 'false' : 'true';
        setStateValue('onboarding_isOpen', newValue);
        setStateValue('topbatches_isOpen', newValue);
        setStateValue('occupation_isOpen', newValue);
        setStateValue('country_isOpen', newValue);
        setStateValue('accordionState', newState);
    };

    useEffect(() => {
        if(state?.data?.onboarding_isOpen == 'true' && state?.data?.topbatches_isOpen == 'true' && state?.data?.occupation_isOpen == 'true' && state?.data?.country_isOpen == 'true') {
            setStateValue('accordionState', 'EXPANDED');
        }

        if(state?.data?.onboarding_isOpen == 'false' && state?.data?.topbatches_isOpen == 'false' && state?.data?.occupation_isOpen == 'false' && state?.data?.country_isOpen == 'false') {
            setStateValue('accordionState', 'COLLAPSED');
        }
        
    },[state?.data?.onboarding_isOpen, state?.data?.topbatches_isOpen, state?.data?.occupation_isOpen, state?.data?.country_isOpen]);

    function extractData(data: any[] = []) {
    if (!Array.isArray(data) || data.length === 0) {
        return { gridData: [], columnHeaders: [] };
    }
    
    const columnHeaders = Object.keys(data[0]);
    const gridData = data;
    
    return { gridData, columnHeaders };
    }      
    
    const handleExport = async (key: string, freshData: any) => {
        const { gridData, columnHeaders } = extractData(freshData);

        const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });
        XLSX.utils.sheet_add_aoa(worksheet, [columnHeaders]);
        XLSX.utils.sheet_add_json(worksheet, gridData, { origin: 'A2', skipHeader: true });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        let downloadFileName = key;

        XLSX.writeFile(workbook, `${downloadFileName}.xlsx`);
    };

    const [isAlumniReportDownloading, setIsAlumniReportDownloading] = useState<boolean>(false);
    const [isStudentReportDownloading, setIsStudentReportDownloading] = useState<boolean>(false);

    const handleAlumniSummaryDownload = async () => {
        setStateValue('isDownloading', '1');
        setIsAlumniReportDownloading(true);
        const response = await axiosClient()
            .post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/dashboard/alumni-summary`, {})
            .catch((error) => {
                console.error('Error downloading alumni summary:', error);
            });
        
        handleExport('Alumni Summary '+moment().format('DD/MM/YYYY HH:mm:ss'), response?.data);
        setIsAlumniReportDownloading(false);
        setStateValue('isDownloading', '0');
    }

    const handleStudentSummaryDownload = async () => {
        setStateValue('isDownloading', '1');
        setIsStudentReportDownloading(true);
        const response = await axiosClient()
            .post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/dashboard/student-summary`, {})
            .catch((error) => {
                console.error('Error downloading student summary:', error);
            });
        
        handleExport('Student Summary '+moment().format('DD/MM/YYYY HH:mm:ss'), response?.data);
        setIsStudentReportDownloading(false);
        setStateValue('isDownloading', '0');
    }

    return (
        <div className="main flex-1">
            <div className="fixed_srtipe" style={{ display: 'none' }}>
                <i className="reg-srtipe" style={{ height: '342.2px' }}></i>
                <i className="filter-srtipe" style={{ height: '469.8px' }}></i>
            </div>
            <div className="container max-1140 px-lg-0 overflow-hiddens">
                <div className="white-block white-block-notopborderradius p-0 h-100">
                    <div className="row g-2 mb-3 align-items-center p-4 p-md-5">
                        <div className="col-sm">
                            <div className="d-flex flex-column">
                                <h3 data-aos="fade-left" data-aos-delay="600" className="font-35 font-600 mb-0 block-title">
                                Onboarding Dashboard
                                </h3>
                            </div>
                        </div>
                        <div className="col-sm-auto">
                            <div className="d-flex flex-wrap">
                                <div className="dashboard innerpage smart-scroll scrolled-down">              
                                    <a onClick={handleAlumniSummaryDownload} className={`btn btn-green height-40 d-inline-flex align-items-center font-14 text-decoration-none px-4 me-2 ${(state.data.isDownloading === '1' && isStudentReportDownloading) ? 'disabled disable' : ''}`}>
                                        <span className="d-flex align-items-center font-500">
                                            {isAlumniReportDownloading ?
                                            <div className="spinner-border" style={{height:'20px',width:'20px'}} role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div> 
                                            : 'Download Alumni Summary'}
                                        </span>
                                    </a>

                                    {isk12 && <a onClick={handleStudentSummaryDownload} className={`btn btn-green height-40 d-inline-flex align-items-center font-14 text-decoration-none px-4 me-2 ${(state.data.isDownloading === '1' && isAlumniReportDownloading) ? 'disabled disable' : ''}`}>
                                        <span className="d-flex align-items-center font-500">
                                        {isStudentReportDownloading ? 
                                        <div className="spinner-border" style={{height:'20px',width:'20px'}} role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div> 
                                        : 'Download Student Summary'}
                                        </span>
                                    </a>}
                                
                                    <a onClick={toggleAccordionState} data-aos="fade-right" data-aos-delay="600" className="btn btn-border height-40 d-inline-flex align-items-center font-14 text-decoration-none px-4">
                                        <span className="d-flex align-items-center font-500">{state.data.accordionState === 'EXPANDED' ? 'Collapse All' : 'Expand All'}</span>
                                    </a>
                                </div>  
                            </div>
                        </div>
                        <div className="container mt-4">
                            <div className="row justify-content-center">
                                <div className="col-lg-12 px-lg-0">{prop.children}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportLayoutComponent;
